import React, { useEffect, useState } from "react";
import { MagnifyingGlass } from "react-loader-spinner";
import ScrollToTop from "../ScrollToTop";

const opportunities = [
  {
    title: "Preparation de commandes",
    type: "Boutique / logistique",
    description:
      "Participation a la preparation des produits, au controle des commandes et a l'organisation quotidienne.",
  },
  {
    title: "Service client",
    type: "Relation client",
    description:
      "Accompagnement des clients sur les produits, les livraisons, les demandes d'information et le suivi des commandes.",
  },
  {
    title: "Livraison",
    type: "Terrain",
    description:
      "Mise en avant d'un service soigneux et ponctuel pour remettre les commandes dans de bonnes conditions.",
  },
];

const Careers = () => {
  const [loaderStatus, setLoaderStatus] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoaderStatus(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      {loaderStatus ? (
        <div className="loader-container">
          <MagnifyingGlass
            visible={true}
            height="100"
            width="100"
            ariaLabel="magnifying-glass-loading"
            wrapperStyle={{}}
            wrapperclassName="magnifying-glass-wrapper"
            glassColor="#c0efff"
            color="#0aad0a"
          />
        </div>
      ) : (
        <>
          <ScrollToTop />
          <section className="my-lg-14 my-8">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-9 text-center mb-8">
                  <h1 className="fw-bold">Rejoindre Almoune</h1>
                  <p className="lead mb-0">
                    Une page simple pour presenter les types de profils qui peuvent accompagner la boutique.
                  </p>
                </div>
              </div>

              <div className="row g-4">
                {opportunities.map((job) => (
                  <div className="col-lg-4 col-md-6" key={job.title}>
                    <div className="card h-100 border-0 shadow-sm">
                      <div className="card-body p-5">
                        <span className="badge bg-light text-dark border mb-3">{job.type}</span>
                        <h4 className="mb-3">{job.title}</h4>
                        <p className="text-muted mb-0">{job.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="card border-0 shadow-sm mt-6">
                <div className="card-body p-5 text-center">
                  <h5 className="mb-2">Candidature spontanee</h5>
                  <p className="text-muted mb-3">
                    Si vous souhaitez travailler avec Almoune, vous pouvez envoyer votre demande par email.
                  </p>
                  <a href="mailto:contact@almoune.fr" className="btn btn-primary">
                    contact@almoune.fr
                  </a>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default Careers;
